import React from 'react';
import Images from '../assets/AllImages';

const INDOOR = () => {
    return (
        <>

            <main>
                <div className="container-fluid bg-primary py-3 py-md-0">
                    <div className="row  align-items-center">
                        <div className="col-12 col-md-6 px-5">
                            <h5 className='text-white fw-bold'>INDOOR</h5>
                        </div>

                        <div className="col-12 col-md-6 px-5 d-none d-sm-block">
                            <img src={Images.Vactor2} alt="" className='w-50 float-end' />
                        </div>
                    </div>
                </div>
            </main>

            {/* Create a Banner Section */}
            <div className="container-fluid indoor-banner text-md-center text-white mb-5 mb-sm-0 px-0">
                <div className="col-md-8 px-4 px-md-5">
                    <h3 className='fw-bold py-3'>The Heart of Aquatic Sports — All Year Round</h3>
                    <p className='fw-bold'>A World-Class Aquatic Experience Under the Open Sky</p>
                    <p className='fs-6'>Step Arena Indoor is the beating heart of Step Arena’s year-round aquatic activity. Designed to meet international standards, it serves as a professional training and competition environment for swimmers, coaches, beginners, and all age groups seeking to explore or perfect their skills in the water.</p>
                </div>
            </div>

            {/* Create a Facility Section */}

            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-6 px-0 mb-5 mb-sm-0">
                        <img src={Images.Athelete} alt="" className='w-100' />
                    </div>

                    <div className="col-md-6 px-sm-5 py-md-4 px-4 d-flex flex-column justify-content-center">
                        <h4 className='text-primary fw-bold'>Facility Features</h4>
                        <p>Step Aqua Indoor is equipped with three state-of-the-art pools tailored for a wide range of aquatic needs:</p>
                        <ul className='lh-sm'>

                            <li className='text-primary fw-bold'>Olympic Indoor Pool</li>
                            <p>50 meters in length, 8 lanes, with competition-standard depth, designed for international-level races and advanced training.</p>

                            <li className='text-primary fw-bold'>25-Meter Training Pool</li>
                            <p>5 lanes, ideal for technique development, targeted training, and skill-building exercises.</p>

                            <li className='text-primary fw-bold'>Children’s Pool</li>
                            p15 meters in length with a shallow depth, perfect for beginner lessons, play-based learning, and water confidence for the youngest swimmers.

                        </ul>
                        <p>15 meters in length with a shallow depth, perfect for beginner lessons, play-based learning, and water confidence for the youngest swimmers.</p>
                    </div>
                </div>
            </div>


            <div className="container-fluid mb-5 mb-sm-0">
                <div className="row">

                    <div className="col-md-6 px-sm-5 px-4 d-flex flex-column justify-content-center">
                        <h4 className='text-primary fw-bold'>Programs and Possibilities</h4>
                        <p>Step Aqua Indoor enables a wide range of activities:</p>
                        <ul className='text-primary fw-bold'>
                            <li><span className='text-primary fw-bold'>Swimming lessons </span>for all age groups and skill levels</li>
                            <li><span className='text-primary fw-bold'>Licensed competitions </span>on both national and international levels</li>
                            <li><span className='text-primary fw-bold'>Elite training programs </span>for competitive and professional swimmers</li>
                            <li><span className='text-primary fw-bold'>Aquatic therapy and rehabilitation </span>in a safe and controlled environment</li>
                        </ul>
                    </div>

                    <div className="col-md-6 px-0">
                        <img src={Images.SchoolGirl} alt="" className='w-100' />
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-6 px-0 mb-5 mb-sm-0">
                        <img src={Images.Lifegard} alt="" className='w-100' />
                    </div>

                    <div className="col-md-6 p-md-5 p-2 d-flex flex-column justify-content-center">
                        <h4 className='text-primary fw-bold'>Built for Comfort, Safety, and Excellence</h4>
                        <p>The indoor facility offers a blend of functionality and comfort:</p>
                        <ul className='text-primary fw-bold'>
                            <li className='text-primary fw-bold'>Natural lighting throughout the pool area</li>
                            <li className='text-primary fw-bold'>Advanced water filtration and hygiene systems</li>
                            <li className='text-primary fw-bold'>High-standard safety protocols</li>
                            <li className='text-primary fw-bold'>Comfortable spectator seating and athlete-friendly infrastructure</li>
                        </ul>
                        <p>Whether you’re aiming for Olympic-level performance or just beginning your aquatic journey, Step Aqua Indoor is your ideal destination for swimming, recovery, and growth.</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default INDOOR;
